export default __webpack_public_path__ + "static/media/about1.5c7a57a8.png";